import axios from 'axios'
import library from '../../../utils/Library'

export const helpGetOrganizationWithCUIT = async (CUIT) => {
  const TOKEN = sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('organization') +
    '/getByCuitOrganizationCorpEntities'

  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: {
      organizationCuit: CUIT
    }
  })
}
